import PaidForButton from './PaidForButton';
import withHandlers from 'recompose/withHandlers';
import { submitPaidForPayment } from 'src/common/facades/eagle/checkout';
import { getCookies } from '../../../../../facades/eagle/helpers/cookies';
import { localiseUrl } from '../../../../../../../common/utils/format-localised-url';

const enhance = withHandlers({
  handleOnClick: props => () => {
    props.handlePaymentSubmission(async () => {
      try {
        const { orderNumber } = await submitPaidForPayment(getCookies());
        window.location = localiseUrl(props.country, `/checkout-v2/confirmation/${orderNumber}`);
      } catch (error) {
        window.location = localiseUrl(props.country, `/checkout-v2`);
      }
    });
  },
});

export default enhance(PaidForButton);



// WEBPACK FOOTER //
// ./src/client/js/view/components/PaymentMethods/PaymentButton/PaidForButton/index.js